import { authSplitApi } from 'redux/helpers/slice.helpers';
import { FaqIndex } from 'data/types/faq.type';

const FAQ_URL = 'api/faq';

export const faqApi = authSplitApi('faqApi').injectEndpoints({
  endpoints: build => ({
    getFaqIndex: build.query<FaqIndex, void>({
      query: () => FAQ_URL,
      keepUnusedDataFor: 300,
    }),
    getFaqContent: build.query<string, string>({
      query: categoryId => ({
        url: `${FAQ_URL}/${categoryId}`,
        responseHandler: response => response.text(),
      }),
      keepUnusedDataFor: 300,
    }),
  }),
  overrideExisting: false,
});

export const { useGetFaqIndexQuery, useLazyGetFaqContentQuery } = faqApi;
